// @greenlight-spec: 28-it-dashboard-ui.md

/** Drops the collector's `unknown` sentinel so a row is omitted rather than showing it. */
export function knownVersion(value: string | undefined): string | undefined {
  return value === undefined || value === 'unknown' ? undefined : value;
}

/**
 * Commits render short. Only a full 40-hex SHA is truncated: `BUILD_SHA` is not
 * always one, and shortening something that is not a commit would invent a value.
 */
export function shortCommit(value: string): string {
  return /^[0-9a-f]{40}$/.test(value) ? value.slice(0, 7) : value;
}

/**
 * Releases read as `v0.2.3`. The stored value may or may not carry the prefix
 * depending on how the chart was rendered, so it is added only when absent —
 * `vv0.2.3` is the failure this guards.
 */
export function releaseLabel(value: string): string {
  return value.startsWith('v') ? value : `v${value}`;
}
